import { CardProps, FormProps, Layout, LayoutProps } from "antd";
import React from "react";
import authImageCover from "../../../common/images/png/AuthCover.png";
import useAuth from "../../../utils/hooks/useAuth";
import {
  ForgotPasswordPage,
  LoginPage,
  RegisterPage,
  ResetPasswordPage,
} from "./components";
import { SmartAuthPageProps } from "./components/auth/auth.type";
import "./layout.css";

export type AuthProps = SmartAuthPageProps<
  LayoutProps,
  CardProps,
  FormProps
> & {
  renderContent?: (
    content: React.ReactNode,
    title: React.ReactNode
  ) => React.ReactNode;
  title?: React.ReactNode;
};
export const AuthPage: React.FC<AuthProps> = (props) => {
  const { type } = props;
  const renderView = () => {
    switch (type) {
      case "register":
        return <RegisterPage title="Registration" {...props} />;
      case "forgotPassword":
        return (
          <ForgotPasswordPage
            title="Forget Password"
            description="Enter your email address and we’ll send you a link to reset your password."
            {...props}
          />
        );
      case "resetPassword":
        return <ResetPasswordPage title="Reset password" {...props} />;
      default:
        return <LoginPage title="Login" {...props} />;
    }
  };

  return (
    <Layout className="auth-layout-blur">
      <div className="auth-container">
        {renderView()}
        <img
          className="auth-image-cover"
          alt="Auth image cover"
          src={authImageCover}
        />
      </div>
    </Layout>
  );
};
